module.exports = __webpack_public_path__ + "img/shipo-map-tug-new.3fad9b37.svg";